import { useState, useEffect } from 'react';
import { fetchEvents } from '../services/strapi';
import  EventCard  from './EventCard';
const EventList = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getEvents = async () => {
      try {
        setLoading(true);
        const data = await fetchEvents(); // Call fetchEvents
        console.log("Fetched Events Data:", data); // Log fetched data for debugging
        setEvents(data); // Update state with fetched events
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getEvents();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  return (
    <div className="events-grid">
      {events.map(event => (
            <EventCard key={event.id} event={event} />
          ))}
    </div>
  );
};

export default EventList;
